/* eslint no-undef: 0 */
export const LINK_HOME = '/'
export const LINK_HOME_TITLE = Conf.siteName
export const LINK_TO_PRODUCTION = ['www.filmcargo.info', 'filmcargo.info']

export const MENU_TITLE_CONTENT = 'Content'
export const MENU_TITLE_MANAGEMENT = 'Contracts'
export const MENU_TITLE_PLATFORMS = 'FlyPrivate'
export const MENU_TITLE_REPORTING = 'Reports'
export const MENU_TITLE_SETTINGS = 'Settings'

export const LINK_ARCHIVE = 'archive'
export const LINK_ARCHIVE_TITLE = 'Archive'
export const LINK_ARCHIVE_DETAIL = 'history_detail'
export const LINK_CATEGORIES = 'flyprivate_categories_settings'
export const LINK_CATEGORIES_TITLE = 'Film categories'
export const LINK_CATEG_SETTINGS = 'categories_settings'
export const LINK_CATEG_SETTINGS_TITLE = 'Categories settings'
export const LINK_CLIENTS = 'clients'
export const LINK_CLIENTS_TITLE = 'Clients'
export const LINK_CONTRACT = 'contract'
export const LINK_CONTRACTS = 'contracts'
export const LINK_CONTRACTS_TITLE = 'Contracts'
export const LINK_CONTRACT_DETAIL_TITLE = 'Contract detail'
export const LINK_CONTRACT_ITEMS = 'contractitems'
export const LINK_CONTRACT_ITEMS_TITLE = 'Titles'
export const LINK_CONTRACT_TIME_RESTRICTIONS = 'contract_time_restrictions'
export const LINK_CONTRACT_TIME_RESTRICTIONS_TITLE = 'Contract time restrictions'
export const LINK_CONTRACT_TITLE = 'Contract'
export const LINK_ENUMS = 'enums'
export const LINK_ENUMS_TITLE = 'Enums'
export const LINK_ETL_RUNNER = 'etl_runner'
export const LINK_ETL_RUNNER_TITLE = 'ETL Runner'
export const LINK_ETL_RUNNER_ROYALTIES_TITLE = 'Royalties calculation'
export const LINK_FILM = 'film'
export const LINK_FILMCARGO_HELP = 'filmcargo_help'
export const LINK_FILMCARGO_HELP_TITLE = 'Help setup'
export const LINK_FILMS = 'films'
export const LINK_FILMS_TITLE = 'Films'
export const LINK_FILM_DETAIL_TITLE = 'Film detail'
export const LINK_FILM_ITEMS_TITLE = 'Contract details'
export const LINK_FILM_TITLE = 'Film'
export const LINK_FINANCIAL_REPORTS = 'financial_reports'
export const LINK_FINANCIAL_REPORTS_TITLE = 'Financial reports'
export const LINK_FPVTESTING = 'flyprivate_testing'
export const LINK_FPVTESTING_TITLE = 'FlyPrivate testing'
export const LINK_PERSONS = 'persons'
export const LINK_PERSONS_TITLE = 'Artists'
export const LINK_PERSONS_TITLE2 = 'Cast and crew'
export const LINK_PRICING = 'flyprivate_pricing'
export const LINK_PRICING_TITLE = 'Price lists settings'
export const LINK_PUBLISH = 'publish'
export const LINK_PUBLISH_TITLE = 'Publish'
export const LINK_RATING = 'rating'
export const LINK_RATING_TITLE = 'Rating'
export const LINK_REPORTS = 'reports'
export const LINK_REPORTS_TITLE = 'Reports'
export const LINK_REPORT_VIEW = 'report'
export const LINK_REPORT_VIEW_TITLE = 'View reports'
export const LINK_RIGHTS = 'rights'
export const LINK_RIGHTS_TITLE = 'Rights'
export const LINK_PPROLLS_LIST = 'pprolls_list'
export const LINK_PPROLLS_LIST_TITLE = 'Pre/post-rolls overview'
export const LINK_PPROLLS_SETUP = 'pprolls'
export const LINK_PPROLLS_SETUP_TITLE = 'Pre/post-rolls settings'
export const LINK_PPROLLS_UPLOAD = 'pprolls_upload'
export const LINK_PPROLLS_UPLOAD_TITLE = 'Pre/post-rolls upload'
export const LINK_SETTINGS = 'flyprivate_homepage_settings'
export const LINK_SETTINGS_TITLE = 'Homepage settings'
export const LINK_SHOW_REPORTS = 'showreports'
export const LINK_SHOW_REPORTS_TITLE = 'Show reports'
export const LINK_TIERS_SETTINGS = 'tiers_settings'
export const LINK_TIERS_SETTINGS_TITLE = 'Tiers settings'
export const LINK_VATRATES = 'vatrates'
export const LINK_VATRATES_TITLE = 'VAT rates'
export const LINK_XRATES = 'xrates'
export const LINK_XRATES_TITLE = 'Exchange rates'
export const LINK_YOUTUBE_ASSETS = 'youtube_assets'
export const LINK_YOUTUBE_ASSETS_TITLE = 'Data cleansing / YouTube assets'

export const LINK_UPLOADS = 'uploads'
export const LINK_UPLOADS_TITLE = 'Upload queue'
export const LINK_UPLOADS_TITLE_SHORT = 'Upload'

// subentities
export const LINK_FILMS_PRICING = 'flyprivate_pricings'
export const SUBENTITY2ENTITY = {
  [LINK_FILMS_PRICING]: LINK_PRICING
}

// list of titles
export const LINKS_LIST = {}
LINKS_LIST[LINK_ARCHIVE] = LINK_ARCHIVE_TITLE
LINKS_LIST[LINK_CATEGORIES] = LINK_CATEGORIES_TITLE
LINKS_LIST[LINK_CATEG_SETTINGS] = LINK_CATEG_SETTINGS_TITLE
LINKS_LIST[LINK_CLIENTS] = LINK_CLIENTS_TITLE
LINKS_LIST[LINK_CONTRACTS] = LINK_CONTRACTS_TITLE
LINKS_LIST[LINK_CONTRACT_ITEMS] = LINK_CONTRACT_ITEMS_TITLE
LINKS_LIST[LINK_CONTRACT_TIME_RESTRICTIONS] = LINK_CONTRACT_TIME_RESTRICTIONS_TITLE
LINKS_LIST[LINK_ENUMS] = LINK_ENUMS_TITLE
LINKS_LIST[LINK_ETL_RUNNER] = LINK_ETL_RUNNER_ROYALTIES_TITLE
LINKS_LIST[LINK_FILMCARGO_HELP] = LINK_FILMCARGO_HELP_TITLE
LINKS_LIST[LINK_FILMS] = LINK_FILMS_TITLE
LINKS_LIST[LINK_FINANCIAL_REPORTS] = LINK_FINANCIAL_REPORTS_TITLE
LINKS_LIST[LINK_FPVTESTING] = LINK_FPVTESTING_TITLE
LINKS_LIST[LINK_PERSONS] = LINK_PERSONS_TITLE
LINKS_LIST[LINK_PRICING] = LINK_PRICING_TITLE
LINKS_LIST[LINK_PUBLISH] = LINK_PUBLISH_TITLE
LINKS_LIST[LINK_RATING] = LINK_RATING_TITLE
LINKS_LIST[LINK_REPORTS] = LINK_REPORTS_TITLE
LINKS_LIST[LINK_RIGHTS] = LINK_RIGHTS_TITLE
LINKS_LIST[LINK_PPROLLS_LIST] = LINK_PPROLLS_LIST_TITLE
LINKS_LIST[LINK_PPROLLS_SETUP] = LINK_PPROLLS_SETUP_TITLE
LINKS_LIST[LINK_PPROLLS_UPLOAD] = LINK_PPROLLS_UPLOAD_TITLE
LINKS_LIST[LINK_SETTINGS] = LINK_SETTINGS_TITLE
LINKS_LIST[LINK_SHOW_REPORTS] = LINK_SHOW_REPORTS_TITLE
LINKS_LIST[LINK_TIERS_SETTINGS] = LINK_TIERS_SETTINGS_TITLE
LINKS_LIST[LINK_VATRATES] = LINK_VATRATES_TITLE
LINKS_LIST[LINK_XRATES] = LINK_XRATES_TITLE
LINKS_LIST[LINK_YOUTUBE_ASSETS] = LINK_YOUTUBE_ASSETS_TITLE

// reverse links - because of compatibility with backend constants
export const ARCHIVE_LINKS_ONLY = {}
ARCHIVE_LINKS_ONLY[LINK_CATEGORIES] = 'fp_categories'
ARCHIVE_LINKS_ONLY[LINK_SETTINGS] = 'fp_homesett'
ARCHIVE_LINKS_ONLY[LINK_PRICING] = 'fp_pricing'
ARCHIVE_LINKS_ONLY[LINK_FPVTESTING] = 'fp_testing'

// reverse titles
export const ARCHIVE_LINKS_TITLES = {}
ARCHIVE_LINKS_TITLES.fp_categories = LINK_CATEGORIES_TITLE
ARCHIVE_LINKS_TITLES.fp_homesett = LINK_SETTINGS_TITLE
ARCHIVE_LINKS_TITLES.fp_pricing = LINK_PRICING_TITLE
ARCHIVE_LINKS_TITLES.fp_testing = LINK_FPVTESTING_TITLE

export const AUTOSCROLL_ENTITY = [
  LINK_PRICING
]

export const RIGHTS_UNDER = {}
RIGHTS_UNDER[LINK_CATEG_SETTINGS] = LINK_CATEGORIES
RIGHTS_UNDER[LINK_TIERS_SETTINGS] = LINK_PRICING

export const REPORTS_STORAGE = 'savedReportParameters'
export const REPORTS_ATTR_PARAMS = 'attrParameters'

export const FILTER_REMOVE_SELECT = [
  'enum_value_enumtext',
  'enum_value_enumtext_like',
  'fp_category_enumtext',
  'fp_category_enumtext_like'
]

export const FILTER_DATE = {
  apiKey: 'filter__custom1',
  paramItems: [
    // date pairs
    'contract_date', 'contract_end_date',
    'due_date', 'expire_date',
    'publish_date', 'cancel_date',
    'start_license_period', 'end_license_period',
    'valid_from', 'valid_to',
    // one date only!
    'asset_created_dt',
    'archive_date'
  ],
  paramKey: '_filter__date_key',
  paramVal: '_filter__date_val'
}
export const FILTER_REGION = {
  apiKey: 'filter__custom2',
  paramHistory: 8,
  paramItems: ['regions', 'region', 'country'],
  paramKey: '_filter__region_key',
  paramVal: '_filter__region_val'
}
export const HISTORY_FILTER = {
  apiKey: 'filter__custom3',
  paramItems: [
    'contract_end_date',
    'expire_date',
    'cancel_date',
    'end_license_period',
    'valid_to',
    'pay_date'
  ],
  paramKey: '_filter__history_key',
  paramVal: '_filter__history_val',
  entityRestriction: ''
}

// reports - add entities for select/multiselect
export const REPORTS_ADD_ENTITIES = [
  { value: 'clients', text: 'entity - Clients', param: 'name' },
  { value: 'contracts', text: 'entity - Contracts', param: 'name' },
  { value: 'films', text: 'entity - Films', param: 'title' },
  { value: 'flyprivate_all_tiers', text: 'entity - Tiers', param: 'tier', multiparam: ['platform', 'type_sale', 'tier'] }
]

// batch
export const BATCH_ACTION_ASSIGN_FOR_TESTING = 'assignfortesting'
export const BATCH_ACTION_CATEGORIES = 'setcategories'
export const BATCH_ACTION_CATEGORIES_UPDATE = 'updatecategories'
export const BATCH_ACTION_CONTRACT = 'setcontract'
export const BATCH_ACTION_FPVHOMEPAGE = 'setfpvhomepage'
export const BATCH_ACTION_FPVHOMEPAGE_UPDATE = 'setfpvhomepageupdate'
export const BATCH_ACTION_PRICING = 'setpricings'
export const BATCH_ACTION_PRICING_TEMP = 'setpricingstemp'
export const BATCH_ACTION_SETGROUP = 'setgroup'
export const BATCH_ACTION_SETINACTIVE = 'setinactive'
export const BATCH_ACTION_SYNCFILMRATINGS = 'syncfilmratings'
export const BATCH_ACTION_TESTING1 = 'settesting1'
export const BATCH_ACTION_TESTING2 = 'settesting2'
export const BATCH_ACTION_TESTING3 = 'settesting3'
export const BATCH_ACTION_UPLOAD_ARCHIVE = 'uploadarchive'

export const BATCH_ACTION_SETUP = {}
BATCH_ACTION_SETUP[BATCH_ACTION_SETINACTIVE] = {
  icon: 'glyphicon glyphicon-log-out',
  id: 'video_id',
  param: 'title',
  subentity: 'setinactive_custom_subentity',
  title: 'Set as inactive'
}
BATCH_ACTION_SETUP[BATCH_ACTION_PRICING] = {
  icon: 'glyphicon glyphicon-usd',
  id: 'flyprivate_platform_tier_pricing_id',
  param: 'title',
  subentity: 'flyprivate_video_pricing',
  title: 'Set pricings'
}
BATCH_ACTION_SETUP[BATCH_ACTION_PRICING_TEMP] = {
  icon: 'glyphicon glyphicon-object-align-vertical',
  id: 'flyprivate_platform_tier_pricing_id',
  param: 'title',
  subentity: 'flyprivate_video_pricing',
  title: 'Set temporary pricing'
}
BATCH_ACTION_SETUP[BATCH_ACTION_TESTING1] = {
  icon: 'glyphicon glyphicon-film',
  id: 'film_id',
  param: 'tester_id',
  subentity: 'flyprivate_testing_films',
  title: 'Add testing films'
}
BATCH_ACTION_SETUP[BATCH_ACTION_TESTING2] = {
  icon: 'glyphicon glyphicon-oil',
  id: 'tier_id',
  param: 'tester_id',
  subentity: 'flyprivate_testing_tiers',
  title: 'Add subscription plans'
}
BATCH_ACTION_SETUP[BATCH_ACTION_TESTING3] = {
  icon: 'glyphicon glyphicon-facetime-video',
  id: 'film_id',
  param: 'tester_id',
  subentity: 'flyprivate_testing_platform',
  title: 'Add all films from one platform'
}
BATCH_ACTION_SETUP[BATCH_ACTION_ASSIGN_FOR_TESTING] = {
  icon: 'glyphicon glyphicon-film',
  id: 'film_id',
  param: 'title',
  subentity: 'flyprivate_testing_testers',
  title: 'Assign for testing'
}
BATCH_ACTION_SETUP[BATCH_ACTION_SETGROUP] = {
  icon: 'glyphicon glyphicon-user',
  id: 'tester_group',
  param: 'tester_id',
  subentity: 'flyprivate_testing_group',
  title: 'Set group'
}
BATCH_ACTION_SETUP[BATCH_ACTION_CATEGORIES] = {
  icon: 'glyphicon glyphicon-tags',
  id: 'video_id',
  param: 'title',
  subentity: 'flyprivateCategories',
  title: 'Set categories'
}
BATCH_ACTION_SETUP[BATCH_ACTION_CATEGORIES_UPDATE] = {
  icon: 'glyphicon glyphicon-random',
  id: 'id',
  param: 'enum_value',
  subentity: 'flyprivateCategoriesUpdate',
  title: 'Update categories',
  updateMode: true
}
BATCH_ACTION_SETUP[BATCH_ACTION_CONTRACT] = {
  icon: 'glyphicon glyphicon-eur',
  id: 'video_id',
  param: 'title',
  subentity: 'contract',
  title: 'Set contract'
}
BATCH_ACTION_SETUP[BATCH_ACTION_FPVHOMEPAGE] = {
  icon: 'glyphicon glyphicon-tags',
  id: 'id',
  param: 'fp_category_code',
  subentity: 'flyprivate_homepage_settings',
  title: 'Set homepage settings'
}
BATCH_ACTION_SETUP[BATCH_ACTION_FPVHOMEPAGE_UPDATE] = {
  icon: 'glyphicon glyphicon-random',
  id: 'id',
  param: 'fp_category_code',
  subentity: 'flyprivate_homepage_settings_update',
  title: 'Update homepage settings',
  updateMode: true
}
BATCH_ACTION_SETUP[BATCH_ACTION_SYNCFILMRATINGS] = {
  icon: 'glyphicon glyphicon-user',
  id: 'id',
  param: 'title',
  subentity: 'film_rating_sync',
  title: 'Sync film ratings'
}
BATCH_ACTION_SETUP[BATCH_ACTION_UPLOAD_ARCHIVE] = {
  icon: 'glyphicon glyphicon-floppy-save',
  id: 'video_id',
  param: 'title',
  subentity: 'upload_archive_subentity',
  title: 'Move uploaded files to archive'
}

// load options: [name, query, sortcol] all parameters are mandatory
export const LOAD_OPTIONS = {}
LOAD_OPTIONS.films = [
  'films',
  '/films?attrs=["id", "slug", "title", "video_type", "reverse_order"]',
  'title'
]
LOAD_OPTIONS.enums = [
  'enums',
  '/enums/options/',
  'value'
]
LOAD_OPTIONS.clients = [
  'clients',
  '/clients?attrs=["id", "name", "withholding_tax", "vat_rate"]',
  'name'
]
LOAD_OPTIONS.contracts = [
  'contracts',
  '/contracts?attrs=["id", "name", "contract_date", "contract_end_date", "license_period_months", "parent_id", "contract_type"]',
  'name'
]
LOAD_OPTIONS.contractitems = [
  'contractitems',
  '/contractitems?attrs=["id", "contract_id", "film_id", "title"]',
  'title'
]
LOAD_OPTIONS.countriesAlternative = [
  'countriesAlternative',
  '/films/view/countries_alternative?attrs=["id","name","code_alternative","code_ISO"]',
  'id'
]
LOAD_OPTIONS.constantsList = [
  'constantsList',
  '/enums/dbTableExport/constants?attrs=["id","List_code"]',
  'id'
]
LOAD_OPTIONS.flyprivate_pricings = [
  'flyprivate_pricings',
  '/flyprivate_pricing?attrs=["id","platform","tier","type_sale","currency_cd","regions","period_length","period_time_unit","valid_from","valid_to"]',
  'platform'
]
LOAD_OPTIONS.flyprivate_homepage_settings = [
  'flyprivate_homepage_settings',
  '/flyprivate_homepage_settings?attrs=["id", "fp_platform_code", "fp_category_code", "fp_category_type", "homepage_order", "regions", "valid_from", "valid_to"]',
  'id'
]
LOAD_OPTIONS.flyprivate_categories_settings = [
  'flyprivate_categories_settings',
  '/flyprivate_categories_settings?attrs=["id","enum_value","video_id","order","regions","valid_to","valid_from"]',
  'id'
]
LOAD_OPTIONS.flyprivate_all_tiers = [
  'flyprivate_all_tiers',
  '/flyprivate_pricing/all/tiers?attrs=["id","platform","tier","type_sale"]',
  'platform'
]
LOAD_OPTIONS.flyprivate_all_pricings = [
  'flyprivate_all_pricings',
  '/flyprivate_pricing/all/pricings?attrs=["id","flyprivate_platform_tier_id","currency_cd","coming_soon_flag","quality_mobile_price","quality_sd_price","quality_hd_price","quality_uhd_price","regions","valid_to","valid_from"]',
  'id'
]
LOAD_OPTIONS.flyprivate_all_video_pricings = [
  'flyprivate_all_video_pricings',
  '/flyprivate_pricing/all/videoPricings?attrs=["id","flyprivate_platform_tier_pricing_id","video_id","quality_mobile","quality_sd","quality_hd","quality_uhd","regions","valid_to","valid_from"]',
  'id'
]
LOAD_OPTIONS.pprolls = [
  'pprolls',
  '/pprolls?attrs=["id","name"]',
  'name'
]
LOAD_OPTIONS.pprolls_uploads = [
  'pprolls_uploads',
  '/uploads/all/pprolls?attrs=["id","state","file_type","regions","lang","s3_filename"]',
  'id'
]
LOAD_OPTIONS.filmcargo_help = [
  'filmcargo_help',
  '/filmcargo_help?attrs=["id", "path", "value"]',
  'path'
]
LOAD_OPTIONS.vatrates = [
  'vatrates',
  '/vatrates?attrs=["id", "region", "platform", "valid_from", "valid_to"]',
  'id'
]
LOAD_OPTIONS.rating = [
  'rating',
  '/rating?attrs=["id", "name"]',
  'id'
]
LOAD_OPTIONS.flyprivate_testing = [
  'flyprivate_testing',
  '/flyprivate_testing?attrs=["id","tester_id","tester_email","tester_group","platform","platform_auth0"]',
  'tester_email'
]
LOAD_OPTIONS.reports = [
  'reports',
  '/reports?attrs=["id", "name", "purpose", "description", "entity_filter", "entity_filter_default", "link"]',
  'name'
]
LOAD_OPTIONS.timeRestrictions = [
  'timeRestrictions',
  '/contract_time_restrictions?attrs=["id", "date"]',
  'id'
]
LOAD_OPTIONS.timeZonesList = [
  'timeZonesList',
  '/enums/dbTableExport/time_zones?attrs=["zone","country"]',
  'id'
]
LOAD_OPTIONS.uploads = [
  'uploads',
  '/uploads/all/videos?attrs=["id","video_id","state","file_type","s3_path","s3_filename","valid_from","valid_to"]',
  'id'
]
LOAD_OPTIONS.xrates = [
  'xrates',
  '/xrates?attrs=["id", "year", "month", "platform", "exchange_rate", "currency_to" , "currency_from"]',
  'year'
]

// sorting
export const DEFAULT_SORT = {}
DEFAULT_SORT[LINK_FILMS] = {
  _sortField: 'id',
  _sortDir: 'ASC'
}
DEFAULT_SORT[LINK_PERSONS] = {
  _sortField: 'name',
  _sortDir: 'ASC'
}
DEFAULT_SORT[LINK_CLIENTS] = {
  _sortField: 'name',
  _sortDir: 'ASC'
}
DEFAULT_SORT[LINK_CONTRACTS] = {
  _sortField: 'contract_type,name,contract_date',
  _sortDir: 'ASC,ASC,ASC'
}
DEFAULT_SORT[LINK_FINANCIAL_REPORTS] = {
  _sortField: 'id',
  _sortDir: 'ASC'
}
DEFAULT_SORT[LINK_XRATES] = {
  _sortField: 'year,month',
  _sortDir: 'DESC,DESC'
}
DEFAULT_SORT[LINK_CONTRACT_TIME_RESTRICTIONS] = {
  _sortField: 'date',
  _sortDir: 'desc'
}
DEFAULT_SORT[LINK_RATING] = {
  _sortField: 'id',
  _sortDir: 'ASC'
}
DEFAULT_SORT[LINK_REPORTS] = {
  _sortField: 'id',
  _sortDir: 'DESC'
}
DEFAULT_SORT[LINK_PRICING] = {
  _sortField: 'platform_enumtext,currency_cd,period_time_unit,period_length,valid_from',
  _sortDir: 'ASC,ASC,ASC,ASC,ASC'
}
DEFAULT_SORT[LINK_SETTINGS] = {
  _sortField: 'fp_platform_enumtext,regions,homepage_order,valid_from',
  _sortDir: 'ASC,ASC,ASC,ASC'
}
DEFAULT_SORT[LINK_CATEGORIES] = {
  _sortField: 'enum_value_enumtext,order,video_title',
  _sortDir: 'ASC,ASC,ASC'
}
DEFAULT_SORT[LINK_FPVTESTING] = {
  _sortField: 'platform_auth0',
  _sortDir: 'ASC'
}
DEFAULT_SORT[LINK_VATRATES] = {
  _sortField: 'region,platform,valid_from,valid_to',
  _sortDir: 'ASC,ASC,ASC,ASC'
}
DEFAULT_SORT[LINK_CATEG_SETTINGS] = {
  _sortField: 'text',
  _sortDir: 'ASC'
}
DEFAULT_SORT[LINK_TIERS_SETTINGS] = {
  _sortField: 'text',
  _sortDir: 'ASC'
}
DEFAULT_SORT[LINK_PPROLLS_SETUP] = {
  _sortField: 'id',
  _sortDir: 'DESC'
}
DEFAULT_SORT[LINK_PPROLLS_UPLOAD] = {
  _sortField: 'id',
  _sortDir: 'DESC'
}
DEFAULT_SORT[LINK_FILMCARGO_HELP] = {
  _sortField: 'path',
  _sortDir: 'ASC'
}
DEFAULT_SORT[LINK_YOUTUBE_ASSETS] = {
  _sortField: 'id',
  _sortDir: 'ASC'
}
